module.exports = __webpack_public_path__ + "img/T719.4a39585b.jpg";